import {Box, Stack, useTheme, Typography} from "@mui/material";
import {Link} from "react-router-dom";
import styles from "./MenuItem.module.css";

const MenuItem = ({text, icon, path, onClick, active = false}) => {
  const theme = useTheme();
  const Component = path ? Link : "div";

  const handleClick = (e) => {
    if (onClick) {
      e.preventDefault();
      onClick();
    }
  };

  return (
    <Stack
      direction="row"
      spacing={0.8}
      alignItems="center"
      component={Component}
      onClick={handleClick}
      to={path}
      className={`${styles.menuItem} ${active ? styles.menuItemActive : ""}`}
      style={{
        "--item-text": theme.palette.sidebar.itemText,
        "--item-hover-bg": theme.palette.sidebar.itemHoverBg,
        "--item-hover-text": theme.palette.sidebar.itemHoverText
      }}
      sx={{
        justifyContent: "flex-start",
        px: 1,
        py: 1.3,
        textDecoration: "none"
      }}
    >
      <Box className={styles.menuItemIcon}>{icon}</Box>
      <Box className={styles.menuItemText}>
        <Typography variant="menuItem" fontWeight="bold">
          {text}
        </Typography>
      </Box>
    </Stack>
  );
};

export default MenuItem;
